import { useTenant } from '@providers/Tenant';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { LanguagesService } from '../api/languagesService';

export function useListLanguages() {
  const { accountId } = useTenant();
  const service = useMemo(() => new LanguagesService(), []);

  const {
    data,
    hasNextPage: hasMore,
    fetchNextPage: fetchMore,
    ...rest
  } = useInfiniteQuery({
    queryKey: [instructionQueryKeys.listInstructionLanguages],
    queryFn: ({ pageParam: nextToken }) => service.list(accountId, { nextToken }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

  return { data: data?.pages?.flatMap(({ items }) => items), hasMore, fetchMore, ...rest };
}
